import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { useFormWizardaUpdate, useFormWizardState } from '../../context/formWizardProvider';
import { AnimatePresence } from 'framer-motion';
import HeaderWithMenu from '../HeaderWithMenu';
const Wizard = ({ children, wizardId }) => {
    const wrapper = useRef(null);
    const { setWrapperWidth } = useFormWizardaUpdate();
    const { wrapperWidth, positionPercent, moving, goBack, noToolBar, hideMenu } = useFormWizardState();
    useEffect(() => {
        function handleResize() {
            if (wrapper.current !== null) {
                setWrapperWidth(wrapper.current.offsetWidth);
            }
        }
        window.addEventListener("resize", handleResize);
        handleResize();
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    const width = positionPercent || 0;
    return _jsx(_Fragment, { children: _jsxs("div", { id: 'widget', className: noToolBar ? `w-full h-full` : ` bg-secondary-700 md:shadow-card rounded-lg w-full sm:overflow-hidden relative`, children: [_jsx("div", { className: "relative", children: !noToolBar && _jsx("div", { className: "overflow-hidden h-1 flex rounded-t-lg bg-secondary-500", children: _jsx("div", { style: { width: `${width}%`, transition: 'width 1s' }, className: "shadow-none flex flex-col whitespace-nowrap justify-center bg-primary" }) }) }), !hideMenu && _jsx(HeaderWithMenu, { goBack: goBack }), _jsx("div", { className: noToolBar ? 'relative w-full h-full' : `relative px-4`, children: _jsx("div", { className: "flex items-start w-full h-full", ref: wrapper, children: _jsx(AnimatePresence, { initial: false, custom: { direction: moving === "forward" ? 1 : -1, width: wrapperWidth }, children: _jsx("div", { className: `flex flex-nowrap h-full`, children: children }, wizardId) }) }) }), _jsx("div", { id: "widget_root" })] }) });
};
export default Wizard;
